import { Messages } from "../../lib/locale";

export const Portuguese: Messages = {
  name: "Português Brasileiro",
  helpTitle: "Como jogar",
  help1: `Todo dia, há um novo País Misterioso. Seu objetivo é advinhar
  o País Misterioso usando o menor número de tentativas. Cada tentativa incorreta
  aparecerá no globo com uma cor indicando o quão próximo está do país misterioso.
  Quanto mais <b>quente</b> a cor, mais próximo você está da resposta.`,
  help2: `Por exemplo, se o País Misterioso for <b>Japão</b>, então os países a seguir
  apareceriam com as seguintes cores, se chutados:`,
  help3: `Um novo País Misterioso estará disponível a cada dia!`,
  France: "França",
  Nepal: "Nepal",
  Mongolia: "Mongólia",
  "South Korea": "Coréia do Sul",
  Aux1: `<b>["Clique", "Toque"]</b> no globo para jogar`,
  Aux2: "Alguma dúvida?",
  Aux3: "Cheque a área Perguntas Frequentes",
  Footer1: "por Cameron Walker",
  Footer2: "Curtindo o jogo?",
  Footer3: "Pague meu cafezinho",
  Loading: "Carregando...",
  FAQTitle: "Perguntas Frequentes",
  q1: "1. Como a distância entre a resposta e meu palpite é calculada?",
  a1: "A distância entre países é definida como a menor distância entre suas bordas",
  q2: "2. Como eu posso jogar se eu for daltônico ou tiver problemas de visão?",
  a2: "Um modo de alto contraste para Daltônicos pode ser ativado em <button>Configurações</button>.",
  q3: "3. Como o jogo decide quais países são válidos?",
  a3: "Globle usa este <a>framework</a> para determinar o que constitue um palpite válido.",
  q4: "4. Países autônomos, mas não soberanos, estão no jogo?",
  a4: "Alguns territórios vão aparecer numa cor neutra quando seu país soberano for chutado, ex. Greenland (Groênlandia) para Denmark (Dinamarca). A localização destes territórios não impacta a cor do país soberano. A maioria dos territórios pequenos não aparecem no jogo, ex. Curaçao.",
  q5: "5. Acertei o País Misterioso de hoje! Quando posso jogar de novo?",
  a5: "O país misterioso muda e seus palpites são reiniciados à meia-noite no seu horário local.",
  q6: "6. Grafias alternativas dos nomes dos países são aceitas?",
  a6: "Há vários países com múltiplos nomes aceitáveis. Algumas grafias alternativas e nomes anteriores são aceitos, ex. Burma (Birmânia) para Myanmar . Acrônimos também são aceitáveis para nomes com mais de uma palavra, ex. UAE para United Arabe Emirates (Emirados Árabes Unidos).",
  q7: "7. Um país está faltando ou uma fronteira está incorreta. O que eu posso fazer sobre isto?",
  a7: "Geografia pode ser um tema sensível e as fronteiras de alguns países são disputadas. Se você acredita que uma correção deve ser feita, por favor, educadamente, crie um issue no {GitHub} mande uma mensagem direta no {Twitter}.",
  GameTitle: "Jogo",
  Game1: "Insira o nome de um país aqui",
  Game2: "Inserir",
  Game3: "Insira o nome de qualquer país para fazer sua primeira tentativa.",
  Game4: `Arraste, <span>["clique", "toque"]</span>, e dê zoom no globo para te ajudar a decidir seu próximo palpite.`,
  Game5: "Tentativa inválida",
  Game6: "Você já chutou este país",
  Game7: "O país misterioso é {answer}!",
  Game8: "Fronteira mais próxima",
  StatsTitle: "Estatísticas",
  Stats1: "Última vitória",
  Stats2: "Palpites de hoje",
  Stats3: "Jogos ganhos",
  Stats4: "Sequência atual",
  Stats5: "Maior sequência",
  Stats6: "Média de tentativa",
  Stats7: "Méd. Tentativas",
  Stats8: "Reiniciar",
  Stats9: "Compartilhar",
  Stats10: "Tem certeza que quer reiniciar sua pontuação?",
  Stats11: "Estatísticas apagadas.",
  Stats12: "Copiado para a área de transferência!",
  SettingsTitle: "Configurações",
  Settings1: "Tema Diurno",
  Settings2: "Tema Noturno",
  Settings3: "Modo Daltônico Ligado",
  Settings4: "Modo Daltônico Desligado",
  Settings5: "Países",
  Settings6: "Cidades",
  Settings7: "Idioma",
  Settings8: "Globle: Edição Cidades em breve!",
  Settings9: "Praticar",
  Settings10: "Arco-íris ativado",
  Settings11: "Arco-íris desativado",
  Answer: "Resposta",
  Closest: "Mais próximo",
  Guessed: "Chutados",
  PracticeMode: "Você está no modo de treino.",
  PracticeExit: "Sair do modo de treino",
  PracticeNew: "Novo jogo de trino",
  SortByGuesses: "Listar pela ordem dos chutes",
  SortByDistance: "Ordenar pela distância",
};
